<template>
    <div class="py-5 sm:p-6 space-y-6">
        <TableContainer>
            <template #headers>
                <tr>
                    <TableHeader>
                        {{ $t("shared.list.product_name") }}
                    </TableHeader>
                    <TableHeader text-right sm-hidden>
                        {{ $t("shared.list.created_at") }}
                    </TableHeader>
                    <TableHeader text-right sm-hidden>
                        {{ $t("shared.list.updated_at") }}
                    </TableHeader>
                    <TableHeader text-right sm-hidden>
                        {{ $t("shared.list.status") }}
                    </TableHeader>
                    <TableHeader v-if="activeApp === 'player'" text-right sm-hidden>
                        Course analytics
                    </TableHeader>
                    <TableHeader sm-hidden> </TableHeader>
                </tr>
            </template>

            <template #body>
                <slot></slot>
            </template>
        </TableContainer>
    </div>
</template>

<script>
import { TableContainer, TableHeader } from "@easy/ui/tables";
import { mapState } from "vuex";

export default {
    components: { TableContainer, TableHeader },
    name: "cProjectsList",
    computed: {
        ...mapState(["activeApp"]),
    },
};
</script>
